<header>
    <div class="layout-header-full fixed-top">
        <app-header-bare></app-header-bare>
    </div>
</header>

<div class="splash-bg-container">
    <div class="splash-bg">
        <div class="splash-img"></div>
        <div class="splash-img-overlay"></div>
    </div>
</div>
<div class="container-fluid layout-container">
    <div class="row g-0">
        <div class="col">
            <div class="splash-body container">
                <div class="splash-card mx-auto">
                    <ng-content></ng-content>
                </div>
            </div>
        </div>
    </div>
</div>

<app-footer [isLight]="true"> </app-footer>
